<template>
  <v-container fluid class="qmkey-vocabulary-view">
    <v-row dense class="d-flex mb-0 pb-0" style="height: 50px">
      <!-- View Title -->
      <v-col class="d-flex mt-1 mb-0 pb-0 ml-2" md="auto">
        <ViewTitle title="Vocabulary" />
      </v-col>
      <v-col class="d-flex mb-0 pb-0" >
        <v-btn
          rounded
          small
          class="add-button"
          @click.stop="addVocabularyForm()"
          >
            Add Vocabulary
        </v-btn>
        <v-btn
            v-if="(this.sitePath.split('/').length > 2) && (vocabularies.length == 0)"
            rounded
            small
            class="copy-button font-weight-bold"
            @click.stop="copyParentVocabularies()"
            >
              Copy Parent Menus
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      fixed
      small
      :items="vocabularies"
      :headers="fields"
      item-key="id"
      dense
      item-class="qmkey-item-row"
      group-by="vocabulary"      
    >
      <template v-slot:group.header="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length -1" class="qmkey-vocabulary-datatable">
          <v-btn 
            @click="toggle"
            small
            icon
            :ref="group"
            :data-open="isOpen"
          >
            <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
          {{ group }}
        </td>
        <td >
          <v-btn 
            small
            icon
            class="qmkey-add-button-vocabulary"
            @click="addVocabularyKey(group)"
          >
            <v-icon small>mdi-plus</v-icon>
            Add New Key
          </v-btn>
        </td>
      </template>

      <template v-slot:item.vocabulary="{ item }">
        <v-btn
          @click.stop="editVocabularyForm(item.id)"
          text
          small
          class="qmkey-add-button-site"
        >
          {{item.vocabulary}}
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click.stop="editVocabularyForm(item.id)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click.stop="deleteVocabularyForm(item.id)"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>
    <!-- Add /edit dialog -->
    <v-dialog max-width="600px" v-model="showEdit" persistent>
      <v-card
        class="mx-auto"
        :loading="loading">
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn
            text @click="close"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle 
          class="pb-0"
          v-if="modalSubTitle"
        >
          {{ modalSubTitle }}
        </v-card-subtitle>
        <v-card-text>
          <v-form ref="editVocabulary" v-model="valid">
            <v-alert
              :value="alert"
              color="error"
              dark
              icon="mdi-alert"
              transition="scale-transition"
              outlined
              dismissible
              @input="alert=false"
            >
              {{ message }}
            </v-alert>
            <v-text-field
              id="sitename"
              v-model="currentVocabulary.vocabulary"
              type="text"
              required
              placeholder="Enter Vocabulary Name"
              label="Vocabulary name"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              id="vocabularykey"
              v-model="currentVocabulary.key"
              type="text"
              required
              placeholder="Enter Vocabulary Key"
              label="Vocabulary Key"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              id="vocabularyvalue"
              v-model="currentVocabulary.value"
              type="text"
              required
              placeholder="Enter Vocabulary value"
              label="Vocabulary value"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              id="vocabularypath"
              v-model="currentVocabulary.path"
              type="text"
              required
              placeholder="Enter Vocabulary path"
              label="Vocabulary path"
              :rules="[rules.required]"
            ></v-text-field>                
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>          
          <v-btn class="mr-4" @click="processForm">Ok</v-btn>
          <v-btn @click="clear">Clear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Delete vocabulary modal -->
    <v-dialog max-width="500px" v-model="showDelete">
      <v-card
        class="mx-auto"
        :loading="loading"
        >
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
        </v-card-title>
        <v-card-text>
          Do you want to delete vocabulary:
          <strong>{{currentVocabulary.key}}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" @click="processDelete">Ok</v-btn>
          <v-btn @click="showDelete=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>    
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import ViewTitle from '@/components/ViewTitle'
import QVocabulary from '@/api/QVocabularyItem'

export default {
  name: 'VocabularyView',
  components: {
    ViewTitle,
  },

  data() {
    return {
      fields: [
        { value: 'id', text: ''},
        { value: 'vocabulary', text: 'Vocabulary' },
        { value: 'site', text: 'Site' },
        { value: 'key', text: 'Key' },
        { value: 'value', text: 'Value' },
        { value: 'path', text: 'Path' },
        { value: 'actions', text: '', sortable:false },
      ],
      message: null,
      modalTitle: null,
      modalSubTitle: null,
      alert: false,
      showEdit: false,
      loading: false,
      showDelete: false,
      rules: {
        required: value => !!value || "Required.",
      },
      valid: false,
      expanded: [],
      togglers: {},
    }
  },

  computed: {
    ...mapState(['isLoading', 'sitePath']),
    ...mapState('QVocabulary', ['currentVocabulary', 'error', 'vocabularies']),
  },

  mounted: function() {
    this.SET_CURRENT_SITE(this.$session.get('site'))
    this.GET_VOCABULARIES()
  },

  methods: {
    ...mapActions('QVocabulary', [
      'ADD_VOCABULARY',
      'DELETE_VOCABULARY',
      'GET_VOCABULARY',
      'GET_VOCABULARIES',
      'UPDATE_VOCABULARY',
      'COPY_FROM_PARENT',
    ]),
    ...mapMutations('QVocabulary', ['SET_CURRENT_VOCABULARY']),
    ...mapMutations(['SET_CURRENT_SITE', 'SHOW_ALERT']),

    // Helper to display Vocabulary name
    vocabularyTitle(data) {
      return '- - '.repeat(data.indent) + data.vocabulary
    },

    // Forms
    addVocabularyForm(parent) {
      let currentVocabulary = {}
      this.modalTitle = 'Add new vocabulary'
      if (parent !== undefined) {
        currentVocabulary.vocabulary = parent
        this.modalTitle = 'Add new vocabulary key'
      }
      currentVocabulary.path = this.sitePath
      this.SET_CURRENT_VOCABULARY(currentVocabulary)
      this.showEdit = true
      this.alert = false
    },

    async editVocabularyForm(id) {
      this.message = null
      this.SET_CURRENT_VOCABULARY({})
      try {
        await this.GET_VOCABULARY(id)
        this.modalTitle = `Edit vocabulary #${id}`
        this.showEdit = true
      } catch (err) {
        // this.SHOW_ALERT(`Error ${err.response.status} getting vocabulary ${id}`)
        this.render_form_errors(err)
        this.alert = true
      }
    },

    async deleteVocabularyForm(id) {
      this.message = null
      try {
        await this.GET_VOCABULARY(id)
        this.modalTitle = `Delete Vocabulary #${id}`
        this.showDelete = true
      } catch (error) {
        this.SHOW_ALERT(`Error ${error.response.status} getting vocabulary ${id}`)
      }
    },

    async processForm(evt) {
      if (evt) evt.preventDefault()
      this.message = null
      try {
        if (this.currentVocabulary.id !== undefined) {
          await this.UPDATE_VOCABULARY(this.currentVocabulary)
        } else {
          await this.ADD_VOCABULARY(this.currentVocabulary)
        }
        this.showEdit = false
      } catch (error) {
        this.render_form_errors(error)
        this.alert = true
      }
    },

    async processDelete(evt) {
      if (evt) evt.preventDefault()
      try {
        await this.DELETE_VOCABULARY(this.currentVocabulary)
        this.showDelete = false
      } catch (error) {
        this.render_form_errors(error)
      }
    },

    async copyParentVocabularies() {
      try {
        await this.COPY_FROM_PARENT()
      } catch (error) {
        this.render_form_errors(error)
      }
    },
    clear: function() {
      this.message = '';
      this.alert = false;
      this.$refs.editVocabulary.resetValidation()
      this.currentSite = {}
    },
    close: function() {
      this.$refs.editVocabulary.reset()
      this.message = '';
      this.alert = false;
      this.showEdit = false
    },
    toggleAll () {
      Object.keys(this.$refs).forEach(k => {
        //console.log(this.$refs[k])
        this.$refs[k].$el.click()
      })
    },
    closeAll () {
      Object.keys(this.$refs).forEach(k => {
          console.log(this.$refs[k])
          if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
              this.$refs[k].$el.click()
          }
      })
    },
    openAll () {
      Object.keys(this.$refs).forEach(k => {
          if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
              this.$refs[k].$el.click()
          }
      })
    },
    addVocabularyKey(group){
      this.addVocabularyForm(group)
    }
  },
}
</script>


<style lang="scss">
  @import "@/sass/menus.scss";
</style>
